function Header() {
    return (
        <div className="flex items-center justify-between pl-4">
            <h1 className="text-3xl font-bold flex items-center">
                <img src="/logo48.png" alt="Random Vim Challenge Logo" className="h-8 w-8 mr-2" />
                Random Vim Challenge
            </h1>
        </div>
    )
}

export default Header;